export const API_CONFIG = {
  // Hardcoded for native builds - import.meta.env wasn't working reliably
  BASE_URL: 'https://bradanna-field-api.azurewebsites.net',
  ENDPOINTS: {
    // ... rest of your endpoints
    // Auth
    LOGIN: '/api/auth/login',
    UPDATE_PIN: '/api/auth/update-pin',
    
    // Jobs
    JOBS: '/api/jobs',
    JOB_BY_ID: (id: number) => `/api/jobs/${id}`,
    
    // Time
    TIME: '/api/time',
    CLOCK_IN: '/api/time/clock-in',
    CLOCK_OUT: '/api/time/clock-out',
    SHOP_TIME: '/api/time/shop-time',
    EDIT_TIME: '/api/time/edit',
    TIME_ENTRIES: '/api/time',
    CREATE_TIME_ENTRY: '/api/time/create',
    CURRENT_TIME_ENTRY: '/api/time/current',
    CLOCKED_IN_EMPLOYEES: '/api/admin/clocked-in',
    BULK_ADJUST_CLOCK_IN: '/api/time/bulk-adjust-clock-in',
    DELETE_TIME_ENTRY: (id: number) => `/api/time/${id}`,
    ENTRY_AUDIT: (id: number) => `/api/time/${id}/audit`,

    // Time card approval (admin)
    WEEK_APPROVALS_ALL: '/api/time/week-approvals-all',
    APPROVE_WEEK: '/api/time/approve-week',
    UNAPPROVE_WEEK: '/api/time/unapprove-week',

    // Employee timecard modifications (corrections)
    TIMECARD_PENDING: '/api/timecard-review/pending',
    TIMECARD_RESOLVE: '/api/timecard-review/resolve',
    TIMECARD_EMPLOYEE_STATUS: '/api/timecard-review/employee-status',
    TIMECARD_TRUCK_DEPARTURE: '/api/timecard-review/truck-departure',

    // Employee self-service (My Time page)
    TIMECARD_REVIEW_STATUS: '/api/timecard-review/status',
    TIMECARD_REVIEW_ENTRIES: '/api/timecard-review/entries',
    TIMECARD_REVIEW_APPROVE: '/api/timecard-review/approve',
    TIMECARD_REVIEW_CORRECTIONS: '/api/timecard-review/corrections',
    TIMECARD_REVIEW_WITHDRAW: '/api/timecard-review/corrections/withdraw',
    TIMECARD_IS_ASPHALT_CREW: '/api/timecard-review/is-asphalt-crew',
    TIMECARD_MY_STATS: '/api/timecard-review/my-stats',
    
    // Trucks
    TRUCKS: '/api/trucks',
    SCAN_TICKET: (id: number) => `/api/trucks/${id}/scan`,
    VERIFY_TICKET: (id: number) => `/api/trucks/${id}/verify`,
    
    // Equipment
    EQUIPMENT: '/api/equipment',
    CHECKOUT_EQUIPMENT: '/api/equipment/checkout',
    RETURN_EQUIPMENT: (id: number) => `/api/equipment/${id}/return`,
    EQUIPMENT_ISSUE: '/api/equipment/issue',
    EQUIPMENT_BY_JOB: (jobId: number) => `/api/equipment/job/${jobId}`,
    
    // Maintenance
    MAINTENANCE: '/api/maintenance',
    MAINTENANCE_HISTORY: (equipmentId: number) => `/api/maintenance/${equipmentId}`,
    
    // Daily Reports
    DAILY_REPORTS: '/api/daily-reports',
    APPROVE_REPORT: (id: number) => `/api/daily-reports/${id}/approve`,

    // Daily Summary
    DAILY_SUMMARY_BY_DATE: (date: string) => `/api/daily-summary/by-date/${date}`,
    DAILY_SUMMARY_AVAILABLE_DATES: '/api/daily-summary/available-dates',

    // T&M Tickets
    TM_TICKETS: '/api/tm-tickets',

    // Safety
    SAFETY_INCIDENT: '/api/safety/incident',
    SAFETY_NEAR_MISS: '/api/safety/near-miss',
    SAFETY: '/api/safety',
    UPDATE_INCIDENT_STATUS: (id: number) => `/api/safety/${id}/status`,
    
    // Employees
    EMPLOYEES: '/api/employees',
    EMPLOYEE_BY_ID: (id: number) => `/api/employees/${id}`,
    UPDATE_EMPLOYEE_PIN: (id: number) => `/api/employees/${id}/pin`,
    DEACTIVATE_EMPLOYEE: (id: number) => `/api/employees/${id}/deactivate`,
    
    // Health
    HEALTH: '/health',

    // AI
    SPELLCHECK_JOB_NAME: '/api/ai/spellcheck-job-name',

    // Job Activity
    JOB_ACTIVITY_STATS: (id: number) => `/api/jobs/${id}/activity-stats`,
    EQUIPMENT_ISSUES_LIST: '/api/equipment/issues',
  }
};
